// Autogenerated file
export const counterpartyStatusesEnum = {
    None: "None",
    Priority: "Priority",
    Suspended: "Suspended",
};
export const counterpartyStatuses = [
    { label: "Без свойств", value: "None" },
    { label: "Приоритетный", value: "Priority" },
    { label: "Приостановлен", value: "Suspended" },
];
